// Flags numbers in edited summary text that don't appear anywhere in the
// report data, so a reviewer notices a typo or an invented figure before the
// PDF goes to a partner. It warns; it doesn't block (staff may rephrase).

const collectNumbers = (value, out) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    out.add(value);
    out.add(Math.round(value * 10) / 10);
    out.add(Math.round(value));
  } else if (Array.isArray(value)) {
    value.forEach((item) => collectNumbers(item, out));
  } else if (value && typeof value === 'object') {
    Object.values(value).forEach((item) => collectNumbers(item, out));
  }
  return out;
};

export const reportNumbers = (...sources) => {
  const out = new Set();
  sources.forEach((source) => collectNumbers(source, out));
  return out;
};

// Numbers written in the text: "22,095", "32.8%", "2026".
const NUMBER_RE = /\d[\d,]*(?:\.\d+)?/g;

export const unknownNumbers = (text, allowed) =>
  [...new Set(text.match(NUMBER_RE) ?? [])].filter((raw) => {
    const value = Number(raw.replace(/,/g, ''));
    if (!Number.isFinite(value)) return false;
    // Small counting words like "3 key points" or "5" are fine to write.
    if (value <= 10 && Number.isInteger(value)) return false;
    return !allowed.has(value) && !allowed.has(Math.round(value * 10) / 10);
  });
